import { RoundDetails } from './RoundDetails';

export default RoundDetails;
